import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const CREATE_SUB_PRACTICE = 'CREATE_SUB_PRACTICE';
export const CREATE_SUB_PRACTICE_SUCCESS = 'CREATE_SUB_PRACTICE_SUCCESS';
export const CREATE_SUB_PRACTICE_FAILURE = 'CREATE_SUB_PRACTICE_FAILURE';

// Action Creators
export const createSubPracticeRequest = () => ({
  type: CREATE_SUB_PRACTICE,
});

export const createSubPracticeSuccess = (users) => ({
  type: CREATE_SUB_PRACTICE_SUCCESS,
  payload: users,
});

export const createSubPracticeFailure = (error) => ({
  type: CREATE_SUB_PRACTICE_FAILURE,
  payload: error,
});

// Thunk Function
export const createSubPractice = (external, body) => {
  return async (dispatch) => {
    dispatch(createSubPracticeRequest());
    try {
      const response = await postMethodWithToken(url.createSubPractice, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(createSubPracticeSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(createSubPracticeFailure(error?.message));
    }
  };
};
